import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface ResendVerifyEmailRequestModel {
	readonly userId: string;
}

export const useResendVerifyEmail = () => {
	const http = useHTTP("None");

	const mutationFn: MutationFunction<HTTPResponse, ResendVerifyEmailRequestModel> = requestModel => {
		return http<undefined, ResendVerifyEmailRequestModel>({
			method: "POST",
			url: "/auth/resend",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
